import { get } from 'lodash/fp';
import axios from './axios';

export default (jobUid, { bookJobSucceeded = false, addToCartSucceeded = false }) =>
  axios.post(
    '/backfill/add-to-cart',
    {
      jobUid,
      bookJobSucceeded,
      addToCartSucceeded,
    },
  ).then(get('data'));
